import React from "react";
import "./ChantSwitch.css";
import { Switch } from "antd";

const ChantSwitch = ({
  label,
  checked,
  onChange,
  size = "default",
  disabled = false,
  loading = false,
}) => {
  return (
    <div className="chant-switch-container">
      <span className="chant-switch-label">{label}</span>
      <Switch
        checked={checked}
        onChange={onChange}
        size={size}
        disabled={disabled}
        loading={loading}
      />
    </div>
  );
};

export default ChantSwitch;
